// extracted by mini-css-extract-plugin
module.exports = {"all":"table_all__3D-OI","rating_table":"table_rating_table__ivaOd"};